/**
 * Logging Levels
 * In order (lowest to highest): TRACE, DEBUG, INFO, LOG, WARN, ERROR
 * @export
 * @enum {number}
 */
export enum LogLevel {
  TRACE,
  DEBUG,
  INFO,
  LOG,
  WARN,
  ERROR
}

export class LoggerConfig {
  /**
   * The minimum logging level for logging to console
   *
   * @static
   * @type {LogLevel}
   * @memberof LoggerService
   */
  public static LocalLogLevel: LogLevel = LogLevel.LOG;

  /**
   * The minimum logging level for logging to the server (eg. New Relic)
   *
   * @static
   * @type {LogLevel}
   * @memberof LoggerService
   */
  public static ServerLogLevel: LogLevel = LogLevel.LOG;
}

function setDebugLogLevel(type: string, enabled: boolean, metadata: string) {
  const capMetadata = metadata.toUpperCase();
  if (enabled && LogLevel[capMetadata] > -1) {
    LoggerConfig[type] = LogLevel[capMetadata];
  } else {
    LoggerConfig[type] = LogLevel.LOG;
  }
}

export function setLocalLogLevel(enabled: boolean, metadata: string = '') {
  setDebugLogLevel('LocalLogLevel', enabled, metadata);
}

export function setServerLogLevel(enabled: boolean, metadata: string = '') {
  setDebugLogLevel('ServerLogLevel', enabled, metadata);
}

// Debug Flag
export const LOG_ALL_STORE_ACTIONS_FLAG = [
  {
    name: 'local_log_level',
    hasMetadata: true,
    metadataHint: 'Error, Warn, Log, Info, Debug, Trace (Default: Log)',
    onChange: setLocalLogLevel
  },
  {
    name: 'server_log_level',
    hasMetadata: true,
    metadataHint: 'Error, Warn, Log, Info, Debug, Trace (Default: Log)',
    onChange: setServerLogLevel
  }
];
